// src/errors.ts
var ChainNotConfiguredForConnectorError = class extends Error {
  constructor(_ref) {
    let {
      chainId,
      connectorId
    } = _ref;
    super("Chain \"".concat(chainId, "\" not configured for connector \"").concat(connectorId, "\"."));
    this.name = "ChainNotConfiguredForConnectorError";
  }
};
var ConnectorNotFoundError = class extends Error {
  constructor() {
    super(...arguments);
    this.name = "ConnectorNotFoundError";
    this.message = "Connector not found";
  }
};
export { ChainNotConfiguredForConnectorError, ConnectorNotFoundError };